import React, { useState, useEffect } from 'react';
import ECharts from 'echarts-for-react';

const Allocation = ({ data }) => {

	const [options, setOptions] = useState();
	
	useEffect(() => {
		if (data !== null) {
			const lineColor = ['#ff7700', '#1D2A53'];
			const backgroundColor = ['#ff770085', '#1d2a5385'];
			const fontColor = ['#ff7700', '#1D2A53'];

			const option = {
				tooltip: {
					trigger: 'item',
					textStyle: { fontSize: 10 },
				},
				legend: {
					bottom: 0,
					itemHeight: 1,
					textStyle: { fontSize: 12 },
					data: [{
						name: data[0].name,
						itemStyle: { color: lineColor[0] },
					}, {
						name: data[1].name,
						itemStyle: { color: lineColor[1] },
					}]
				},
				radar: {
					axisName: {
						fontSize: 12,
						fontWeight: 700,
						color: '#000000',
						// 축 라벨(성장/성과/가치/안정성/모멘텀)을 바깥으로 더 밀어서
						// 시리즈 점수 라벨과 겹치지 않도록 여백을 확보합니다.
						padding: [8, 8, 8, 8],
						margin: 14,
						overflow: 'truncate'
					},
					indicator: [
						{ name: '성장', max: 100 },
						{ name: '성과', max: 100 },
						{ name: '안정성', max: 100 },
						{ name: '모멘텀', max: 100 },
						{ name: '가치', max: 100 }
					],
					// 상단(성장) 라벨이 컨테이너 밖으로 잘리는 현상을 방지하기 위해
					// 차트 중심을 약간 아래로 내립니다.
					center: ['50%', '55%'],
				},
				series: [
					{
						type: 'radar',
						data: [
							{
								value: data[0].value,
								name: data[0].name,
								symbol: 'circle',
								symbolSize: 5,
								itemStyle: { color: lineColor[0] },
								lineStyle: { color: lineColor[0], width: 2},
								areaStyle: {
									color: backgroundColor[0]
								},
								label: {
									show: true,
									color: fontColor[0],
									fontSize: 10,
								}
							},
							{
								value: data[1].value,
								name: data[1].name,
								symbol: 'circle',
								symbolSize: 5,
								itemStyle: { color: lineColor[1] },
								lineStyle: { color: lineColor[1], width: 2 },
								areaStyle: {
									color: backgroundColor[1]
								},
								label: {
									show: true,
									color: fontColor[1],
									fontSize: 11,
								}
							},
						],
						symbol: 'none'
					}
				]
			}
			setOptions(option);
		}
	}, [data]);

	return (
			<div className="chart chart1" style={{width: '100%', height: '250px'}}>
				{ options && 
					<ECharts option={options} style={{ width: '100%', height: '100%' }} />
				}
			</div>
  );
}

export default Allocation;
